import BaseModel from "./BaseModel"

export default class BankAccountModel extends BaseModel {
    get schema() {
        return {
            bik: "",
            settlement_account: "",
            correspondent_account: "",
            personal_account: "",
            name: "",
            address: "",
            is_main: false
        }
    }

    prepareCreate() {
        this.baseClear()

        return this
    }

    prepareUpdate() {
        this.baseClear()

        return this
    }
}
